export default __webpack_public_path__ + "static/media/webpay.28a3bc87.svg";